
import typography from "assets/theme/base/typography";
import colors from "assets/theme/base/colors";

// Template Dashboard 2 MUI helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { size, fontWeightRegular } = typography;
const { grey, dark, secondary } = colors;

const stepLabel = {
  styleOverrides: {
    label: {
     
    },
  },
};

export default stepLabel;
